import * as R from "ramda";
import React, { Component } from "react";
import FlexView from "react-flexview";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../modules/popup/SimpleAlert";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import Api from "../../../../Services/Api";
import { getValueFromDDL } from "../../../common/mapper";
import ReceivingPartDGIInputs from "./receivingPartDGIInputs";
import dayjs from "dayjs";
import { mapToObjectDDL } from "../../../common/mapper";
import HotlineDetailDataInput from "../hotlineDetailDataInput";
import { contructQueryParam, fetchDataAsync } from "../../../../Services/Utils";
import { constructGenSeqPayload } from "../utilUpdate";
import { withStyles } from "@material-ui/core/styles";
import { defaultTableChange } from "../../../../modules/custom/customTable";

const styles = {
  forceGray: {
    backgroundColor: "#bfbaba !important",
    color: "#000000 !important",
    cursor: "not-allowed",
  },
};

class ReceivingPartDGIProcess extends Component {
  getTableColumns = () => {
    return [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (value, tableMeta) => {
            return <>{tableMeta.rowIndex + 1}</>;
        },
          setCellProps: () => ({
            style: { width: "5%" },
          }),
          sort: false,
        },
      },
      {
        name: "part.partCode",
        label: "Kode Part*",
        options: {
          setCellProps: () => ({
            style: { minWidth: "150px" },
          }),
        },
      },
      {
        name: "part.partName",
        label: "Nama Part",
        options: {
          setCellProps: () => ({
            style: { minWidth: "150px" },
          }),
        },
      },
      {
        name: "part.partCategory",
        label: "Kategori",
        options: {
          setCellProps: () => ({
            style: { minWidth: "150px" },
          }),
        },
      },
      {
        name: "quantity",
        label: "QTY",
        options: {
          setCellProps: () => ({
            style: { minWidth: "150px" },
          }),
        },
      },
      {
        name: "qtyTerima",
        label: "QTY Diterima",
        options: {
          customBodyRender: (val, { rowIndex, rowData }) => {
            // const isSaved = rowData[rowData.length - 1];
            const msgError = this.state.errors?.part?.[rowIndex]?.qtyTerima;
            return (
              <>
                <SimpleInput
                  id="input_text_qty"
                  box="onlyNumber"
                  name="qtyTerima"
                  // readOnly={isSaved}
                  containerclassname="margin-bottom-none"
                  value={val}
                  onChange={({ target }) =>
                    this.handleValueChange(rowIndex, target.name, target.value)
                  }
                />
                {msgError && (
                  <p
                    className="error-text"
                    style={{ color: "red", fontSize: 12 }}
                  >
                    {msgError}
                  </p>
                )}
              </>
            );
          },
          setCellProps: () => ({
            style: { minWidth: "100px" },
          }),
        },
      },
      {
        name: "purchaseOrderNo",
        label: "No. PO",
        options: {
          setCellProps: () => ({
            style: { minWidth: "150px" },
          }),
        },
      },
      {
        name: "orderType",
        label: "Jenis Order*",
        options: {
          customBodyRender: (value, { rowIndex, rowData }) => {
            const msgError = this.state.errors?.part?.[rowIndex]?.orderType;
            return (
              <>
                <SimpleDDL
                  id={`select_options_order_type_${rowIndex}`}
                  containerclassname="margin-bottom-none width width-250px"
                  box="search"
                  value={
                    typeof value === "string"
                      ? { label: value, value: value }
                      : value
                  }
                  menuPosition="fixed"
                  onChange={(val) => this.handleOrderTypeChange(rowIndex, val)}
                  options={
                    this.state.dataOrderType
                      ? this.state.dataOrderType.map((item) =>
                          mapToObjectDDL(item.label, item.value),
                        )
                      : []
                  }
                  isClearable={true}
                />
                {msgError && (
                  <p
                    className="error-text"
                    style={{ color: "red", fontSize: 12 }}
                  >
                    {msgError}
                  </p>
                )}
              </>
            );
          },
          setCellProps: () => ({
            style: { minWidth: "250px" },
          }),
        },
      },
      {
        name: "orderHotlineNumber",
        label: this.getHotlineLabel(),
        options: {
          customBodyRender: (value, { rowIndex, rowData }) => {
            const msgError =
              this.state.errors?.part?.[rowIndex]?.hotlineOrderNo;

            const isHotline =
              rowData[7] === "HOTLINE" ||
              rowData[7]?.value === "HOTLINE" ||
              rowData[7]?.label === "HOTLINE";

            return (
              <div>
                <FlexView vAlignContent="center">
                  <SimpleInput
                    id={`input_text_hotline_${rowIndex}`}
                    name="orderHotlineNumber"
                    containerclassname="margin-bottom-none"
                    value={rowData.orderHotlineNumber || ""}
                    readOnly={!isHotline}
                    onChange={({ target }) =>
                      this.handleValueChange(
                        rowIndex,
                        target.name,
                        target.value,
                      )
                    }
                  />
                  <SimpleButton
                    styles={{ marginTop: 5, width: "auto", height: 38 }}
                    text="..."
                    className={!isHotline ? this.props.classes.forceGray : ""}
                    onClick={this.handleDetailHotlineVisible}
                  />
                </FlexView>
                {msgError && (
                  <p
                    className="error-text"
                    style={{ color: "red", fontSize: 12, marginTop: 4 }}
                  >
                    {msgError}
                  </p>
                )}
              </div>
            );
          },
          setCellProps: () => ({ style: { minWidth: "250px" } }),
        },
      },
      {
        name: "locatorCode",
        label: "Locator*",
        options: {
          customBodyRender: (value, { rowIndex, rowData }) => {
            // const isSaved = rowData[rowData.length - 1];
            const msgError = this.state.errors?.part?.[rowIndex]?.locatorCode;
            return (
              <>
                <SimpleDDL
                  id={`select_options_locator_${rowIndex}`}
                  containerclassname="margin-bottom-none width width-250px"
                  box="search"
                  value={value}
                  menuPosition="fixed"
                  onChange={(value) =>
                    this.handleSingleLocatorChange(rowIndex, value)
                  }
                  options={
                    this.state.dataLocator
                      ? this.state.dataLocator.map((item) =>
                          mapToObjectDDL(item.nameLocation, item.kodeLocation),
                        )
                      : []
                  }
                  // readOnly={isSaved}
                  isClearable={true}
                />
                {msgError && (
                  <p
                    className="error-text"
                    style={{ color: "red", fontSize: 12 }}
                  >
                    {msgError}
                  </p>
                )}
              </>
            );
          },
          setCellProps: () => ({
            style: { minWidth: "250px" },
          }),
        },
      },
    ];
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      alertInformation: null,
      noSPBP: null,
      dataLocator: [],
      expedisiOptions: [],
      formData: {},
      data: props.data || {},
      dataPart: [],
      dataSupplier: [],
      dataOrderType: [
        {
          label: "FIX",
          value: "FIX",
        },
        {
          label: "REGULER",
          value: "REGULER",
        },
        {
          label: "HOTLINE",
          value: "HOTLINE",
        },
        {
          label: "URGENT",
          value: "URGENT",
        },
      ],
      dataTable: [],
      errors: {
        supplierId: null,
        part: {},
      },
      pagination: {
        page: 1,
        limit: 5,
        totalData: 0,
      },
    };
  }

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  async componentDidMount() {
    this.handleTriggerLoading();
    await this.fetchDataPart();
    this.fetchDataLocator();
    this.fetchDataSupplierExpedition();
    this.fetchGetNoSPBP();
    this.fetchDataSupplier();
    this.handleTriggerLoading();
  }

  fetchDataSupplier = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA")
          .getSupplierMainDealerBySourceCode,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.data.kodeCabang,
        }),
      });
      console.log(response);

      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataSupplier: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchGetNoSPBP = async () => {
    let payload = constructGenSeqPayload(this.props.data.kodeCabang);
    try {
      let res = await Api.create("NAGAMAS_MASTER_DATA").getGenSeqWithoutSave(
        payload,
      );
      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          noSPBP: res.data,
        }));
      }
    } catch (error) {
      console.log("error: ", error);
    }
  };

  fetchDataPart = async () => {
    try {
      const response = await Api.create("NAGAMAS_MASTER_DATA").getAllMasterPart(
        { paramFilters: {} },
      );
      console.log(response);

      if (response.ok) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataPart: response.data.data,
        }));
      }
    } catch (e) {
      console.log("errors", e);
    }
  };

  fetchDataLocator = async () => {
    console.log(this.props);

    try {
      let res = await Api.create(
        "NAGAMAS_MASTER_DATA",
      ).getAllMasterLocationPagingByParam({
        paramFilters: { kodeCabang: this.props.data.kodeCabang },
        page: null,
        limit: null,
      });

      if (res.ok) {
        this.setState((prevState) => ({
          ...prevState,
          dataLocator: res.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  fetchDataSupplierExpedition = async () => {
    try {
      let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllSupplierExpedition,
        menuName: "Receiving Unit - DGI",
        setError: this.props.setError,
        args: contructQueryParam({
          kodeCabang: this.props.data.kodeCabang,
        }),
      });
      if (response.ok) {
        this.setState((prevState) => ({
          ...prevState,
          expedisiOptions: response.data.data,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
  };

  hasHotlineOrder = () => {
    const data = this.state.data?.data || [];

    return data.some(
      (row) =>
        row?.orderType === "HOTLINE" ||
        row?.orderType?.value === "HOTLINE" ||
        row?.orderType?.label === "HOTLINE",
    );
  };

  getHotlineLabel = () => {
    const hasHotline = this.hasHotlineOrder();

    return hasHotline ? (
      <span>
        No Hotline Order <span style={{ color: "red" }}>*</span>
      </span>
    ) : (
      "No Hotline Order"
    );
  };

  handleSelectPart = (rowIndex, option) => {
    const part = this.state.dataPart.find((p) => p.kodePart === option.value);
    if (!part) return;

    this.setState((prev) => {
      const rows = [...prev.dataTable];
      rows[rowIndex] = {
        ...rows[rowIndex],
        kodePart: part.kodePart,
        namaPart: part.partName,
        kategori: part.partCategory,
      };
      return { ...prev, dataTable: rows };
    });
  };

  handleValueChange = (index, name, value) => {
    console.log(index, name, value);

    this.setState((prev) => {
      const newRows = [...(prev.data?.data || [])];
      newRows[index] = {
        ...newRows[index],
        [name]: value,
      };

      return {
        data: {
          ...prev.data,
          data: newRows,
        },
      };
    });
  };

  handleOrderTypeChange = (index, value) => {
    this.setState((prev) => {
      const newRows = [...(prev.data?.data || [])];
      newRows[index] = {
        ...newRows[index],
        orderType: value,
      };

      return {
        data: {
          ...prev.data,
          data: newRows,
        },
      };
    });
  };

  handleSingleLocatorChange = (index, value) => {
    this.setState((prev) => {
      const newRows = [...(prev.data?.data || [])];
      newRows[index] = {
        ...newRows[index],
        locatorCode: value,
      };

      return {
        data: {
          ...prev.data,
          data: newRows,
        },
      };
    });
  };

  getValue = (key) => {
    const { tab } = this.props;
    return this.props.data?.[tab]?.[key] || null;
  };

  handleDetailHotlineVisible = () => {
    this.setState((prevState) => ({
      ...prevState,
      detailHotlineVisible: !prevState.detailHotlineVisible,
    }));
  };

  handleUpdateTableData = (index, name, value) => {
    this.setState((prevValue) => {
      const newState = [...prevValue.data.listUnitDetail];
      newState[index] = {
        ...newState[index],
        [name]: value,
      };
      return {
        ...prevValue,
        data: {
          ...prevValue.data,
          listUnitDetail: newState,
        },
      };
    });
  };

  handleSubmitProcess = async (e) => {
    e.preventDefault();
    const { data } = this.state;
    const originalData = this.props.data?.data || [];

    let hasViolation = false;

    const part = (data.data || []).map((dt, index) => {
      const original = originalData[index];

      const currentOrderType = dt.orderType?.label || dt.orderType;
      const originalOrderType =
        original?.orderType?.label || original?.orderType;

      const isViolation = currentOrderType !== originalOrderType;
      if (isViolation) hasViolation = true;

      return {
        partCode: dt.part?.partCode || "",
        partName: dt.part?.partName || "",
        categoryName: dt.part?.partCategory || "",
        quantity: dt.quantity || 0,
        quantityReceived: parseInt(dt.qtyTerima) || 0,
        purchaseOrderNo: dt.purchaseOrderNo || "",
        orderType: currentOrderType || "",
        hotlineOrderNo: dt.orderHotlineNumber || "",
        locatorId: dt.locatorCode?.value || "",
        locatorName: dt.locatorCode?.label || "",
      };
    });

    const request = {
      id: data.id || "",
      receivingPartDGIId: data.receivingPartDGIId || "",
      shippingNo: data.shippingNo || "",
      numberOfSPBP: data.numberOfSPBP || "",
      invoiceNo: data.noinvoice || "",
      receivedNo: data.receivedNo || "",
      shippingDate: data.shippingDate || "",
      supplierId: data.supplierId?.value || "",
      supplierName: data.supplierId?.label || "",
      carId: data.carId || "",
      expeditionId: data.expeditionId?.value || "",
      expeditionName: data.expeditionId?.label || "",
      note: data.note || "",
      kodeCabang: data.kodeCabang || "",
      hasViolation,
      part,
    };

    let errors = { supplierId: null, part: {} };
    let hasError = false;

    if (!request.supplierId) {
      errors.supplierId = "Field wajib diisi";
      hasError = true;
    }

    request.part.forEach((p, index) => {
      let rowErr = {};

      if (!p.quantityReceived || Number(p.quantityReceived) === 0) {
        rowErr.qtyTerima = "Field wajib diisi";
        hasError = true;
      }

      if (!p.orderType) {
        rowErr.orderType = "Field wajib diisi";
        hasError = true;
      }

      if (!p.locatorId) {
        rowErr.locatorCode = "Field wajib diisi";
        hasError = true;
      }

      console.log(p);

      if (p.orderType === "Hotline" && !p.hotlineOrderNo) {
        rowErr.hotlineOrderNo = "Field wajib diisi";
        hasError = true;
      }

      if (Object.keys(rowErr).length > 0) {
        errors.part[index] = rowErr;
      }
    });

    if (hasError) {
      this.setState({ errors });
      return;
    }

    this.setState({ errors: {} });

    console.log("Final request:", request);

    this.setState({ loading: true });
    const response =
      await Api.create("NAGAMAS_DGI").updateReceivingPartDGI(request);

    if (response.ok && response.data?.data) {
      this.setState({
        alertInformation: {
          error: false,
          content: <p>Data telah disimpan.</p>,
        },
      });
    }
    {
      alert(response.data?.message);
    }

    this.setState({ loading: false });
  };

  handleStateChange = (value) => {
    if (typeof value === "function") {
      this.setState(value);
    } else {
      this.setState(value);
    }
  };

  handleResetForm = () => {
    this.setState(
      {
        data: {
          id: "",
          receivingPartDGIId: "",
          shippingDate: "",
          shippingNo: "",
          receivedNo: "",
          totalQuantity: 0,
          kodeCabang: "",
          data: [],
          supplierId: null,
          carId: "",
          expeditionId: null,
          note: "",
        },
      },
      () => {
        console.log("Form telah direset:", this.state.data);
      },
    );
  };

  handleSelectHotline = (value) => {
    const { tab } = this.props;
    this.setValueObject(tab, value);
    this.handleDetailHotlineVisible();
  };

  handleAlertVisibility = () => {
    if (!this.state.alertInformation.error) {
      this.props.onCloseDetail();
    }
    this.setState((prevValue) => ({ ...prevValue, alertInformation: null }));
  };

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { dataTable, detailHotlineVisible, pagination } = this.state;

    return (
      <>
        <SimpleModal
          title="Proses Terima Part DGI"
          visible={this.props.visible}
          onClickClose={() => this.props.onClickClose()}
          content={
            <ModalContainer>
              <form onSubmit={this.handleSubmitProcess}>
                <ReceivingPartDGIInputs
                  state={this.state}
                  errors={this.state.errors}
                  onSetState={this.handleStateChange}
                />
                <SimpleDataTable
                  key={`${pagination.totalData}-${pagination.page}`}
                  data={this.state.data?.data || []}
                  columns={this.getTableColumns()}
                  toCount={this.state.data?.data.length}
                  rowsPerPage={pagination.limit}
                  page={pagination.page - 1}
                  options={{
                    ...defaultTableChange(
                      this.handleChangePage,
                      this.handleRowsPerPage,
                    ),
                    serverSide: false,
                  }}
                />
                <br />
                <FlexView hAlignContent="right">
                  <SimpleButton
                    type="button"
                    secondary
                    onClick={this.handleResetForm}
                  >
                    Clear
                  </SimpleButton>
                  <SimpleButton type="submit">Simpan</SimpleButton>
                </FlexView>
              </form>
            </ModalContainer>
          }
        />

        {detailHotlineVisible && (
          <HotlineDetailDataInput
            {...this.props}
            visible={detailHotlineVisible}
            title="Cari No. Hotline"
            onSelect={this.handleSelectHotline}
            onClickClose={this.handleDetailHotlineVisible}
          />
        )}
        {this.state.alertInformation !== null && (
          <SimpleAlert
            visible={this.state.alertInformation !== null}
            title="Information"
            onClickClose={this.handleAlertVisibility}
            content={
              <div>
                {this.state.alertInformation.content}
                <SimpleButton
                  className="margin-left-none margin-top-15px"
                  onClick={this.handleAlertVisibility}
                >
                  OK
                </SimpleButton>
              </div>
            }
          />
        )}
        {this.state.loading && (
          <SimpleLoadingOverlay active={this.state.loading} />
        )}
      </>
    );
  }
}

export default withStyles(styles)(ReceivingPartDGIProcess);
